import { store } from '@betacrew/jars-flux'
export const componentKey = "CHECK_STATUS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setStatus: (state, action) => {
            state.status = action.payload;
        },
    }, 
    initialReducerState: {
        loadingState: false,
        status: null,
        
    }
});
export const { setLoadingState, setStatus } = actions;